import React from "react";
import LoaderCSS from "./Loader.module.css";
const Loader = () => {
  return (
    <div className={LoaderCSS.containerLoader}>
      <span className={LoaderCSS.loader}></span>
    </div>
  );
};

export default Loader;
